import type { IDynamicFieldAnswerFormat } from '../types';
import { writableSessionStorage } from './writableSessionStorage';

export type Gender = 'female' | 'male' | 'other';

export interface IUserStore {
	gender?: Gender;
	firstName: string;
	lastName: string;
	mobileNumber: string;
	email: string;
	dataPrivacyConsent: boolean;
	kekConsent: boolean;
	companyName: string;
	// additional fields when providing kek consent
	street: string;
	streetNumber: string;
	postalCode: string;
	city: string;
	userAgent: string;
	extraAnswers: IDynamicFieldAnswerFormat;
	website: string;
}

const initUserData: IUserStore = {
	gender: undefined,
	firstName: '',
	lastName: '',
	mobileNumber: '',
	email: '',
	dataPrivacyConsent: false,
	kekConsent: false,
	street: '',
	streetNumber: '',
	postalCode: '',
	companyName: '',
	city: '',
	userAgent: '',
	extraAnswers: {},
	website: ''
};

const createUserStore = () => {
	const { subscribe, set, update } = writableSessionStorage('userStore', initUserData);

	return {
		subscribe,
		set,
		update
	};
};

export function resetCriticalUserData() {
	let userData: IUserStore | undefined = undefined;
	const unsubscribe = userStore.subscribe((data) => {
		userData = { ...data, extraAnswers: {}, kekConsent: false, dataPrivacyConsent: false };
	});

	unsubscribe();
	if (userData) {
		userStore.set(userData);
	}
}

export const userStore = createUserStore();
